import { render, staticRenderFns } from "./PlantManagerMenu.vue?vue&type=template&id=841f5e44&"
import script from "./PlantManagerMenu.vue?vue&type=script&lang=ts&"
export * from "./PlantManagerMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PlantManagerMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports